import { history } from 'src/store/config';

export const getCurrentUrl = () => {
  return new Promise((resolve, reject) => {
    resolve(window.location.href);
  })
}

export const navigateUser = (roleId: any) => {
  switch (roleId) {
    case 1:
    case 4:
      history.push('/hq-admin-dashboard/0');
      break;
    case 6: 
      history.push('/hq-admin-dashboard/0');
      break;
    case 2:
      history.push('/regional-admin-dashboard/0');
      break;
    case 3:
      history.push('/data-collector-dashboard/0');
      // history.push('/surveyreports');
      break;
    case 5:
      history.push('/surveyreports');
    break;
    case 8:
    case 7: history.push('/regional-admin-dashboard/0');
    break;
    default:
      history.push('/login');
  }
}

export const getStatus = (status: any) => {
  switch (status) {
    case "Draft":
      return "btn-blue-primary"

    case "Pending":
      return "btn-blue-primary"

    case "InActive":
      return "btn-grey-primary"

    case "Active":
      return "btn-green-primary"

    case "Closed":
      return "btn-black-primary"

    case "Rejected":
      return "btn-red-primary"

    default:
      return '';
  }
}


// WEBPACK FOOTER //
// ./src/effects/utils/common.tsx